import { useId } from 'react';

const DRUPELETS: [number, number][] = [
  [12, 9.2],
  [8.6, 10.6],
  [15.4, 10.6],
  [10.2, 13.2],
  [13.8, 13.2],
  [7.4, 14],
  [16.6, 14],
  [12, 16.4],
  [9, 17.2],
  [15, 17.2],
  [12, 19.8],
  [10.4, 20.6],
  [13.6, 20.6],
];

/** The FarmOS mark: a berry in the app's indigo with two leaves. */
export function BrandMark({ className }: { className?: string }) {
  const id = useId();
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <defs>
        <radialGradient id={id} cx="35%" cy="30%" r="80%">
          <stop offset="0" stopColor="#8a8df2" />
          <stop offset=".6" stopColor="#5b5fd9" />
          <stop offset="1" stopColor="#3f43b3" />
        </radialGradient>
      </defs>
      <path d="M12 7.2C10.6 4.6 8.2 3.6 5.6 4.2 7 6.6 9.2 7.6 12 7.2Z" fill="#5fae62" />
      <path d="M12 7.2c1.6-2.8 4-3.8 6.6-3.2-1.4 2.6-3.6 3.6-6.6 3.2Z" fill="#4f9d5b" />
      {DRUPELETS.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r="2.35" fill={`url(#${id})`} />
      ))}
    </svg>
  );
}
